import { Injectable } from '@angular/core';
import { CalsoftMockApiRequestHandler } from './mock-api.request-handler';

@Injectable({
    providedIn: 'root'
})
export class CalsoftMockApiService
{
    requestHandlers: any;

    /**
     * Constructor
     */
    constructor()
    {
        // Set the defaults
        this.requestHandlers = {
            delete: new Map<string, CalsoftMockApiRequestHandler>(),
            get   : new Map<string, CalsoftMockApiRequestHandler>(),
            patch : new Map<string, CalsoftMockApiRequestHandler>(),
            post  : new Map<string, CalsoftMockApiRequestHandler>(),
            put   : new Map<string, CalsoftMockApiRequestHandler>()
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register 'delete' request handler
     *
     * @param url
     * @param delay
     */
    onDelete(url: string, delay: number = 0): CalsoftMockApiRequestHandler
    {
        return this._registerRequestHandler('delete', url, delay);
    }

    /**
     * Register 'get' request handler
     *
     * @param url
     * @param delay
     */
    onGet(url: string, delay: number = 0): CalsoftMockApiRequestHandler
    {
        return this._registerRequestHandler('get', url, delay);
    }

    /**
     * Register 'patch' request handler
     *
     * @param url
     * @param delay
     */
    onPatch(url: string, delay: number = 0): CalsoftMockApiRequestHandler
    {
        return this._registerRequestHandler('patch', url, delay);
    }

    /**
     * Register 'post' request handler
     *
     * @param url
     * @param delay
     */
    onPost(url: string, delay: number = 0): CalsoftMockApiRequestHandler
    {
        return this._registerRequestHandler('post', url, delay);
    }

    /**
     * Register 'put' request handler
     *
     * @param url
     * @param delay
     */
    onPut(url: string, delay: number = 0): CalsoftMockApiRequestHandler
    {
        return this._registerRequestHandler('put', url, delay);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register a request handler
     *
     * @param requestType
     * @param url
     * @param delay
     * @private
     */
    private _registerRequestHandler(requestType, url, delay): CalsoftMockApiRequestHandler
    {
        // Create a new instance of CalsoftMockApiRequestHandler
        const calsoftMockHttp = new CalsoftMockApiRequestHandler();

        // Store the url
        calsoftMockHttp.url = url;

        // Store the delay
        calsoftMockHttp.delay = delay;

        // Store the request handler to access them from the interceptor
        this.requestHandlers[requestType].set(url, calsoftMockHttp);

        // Return the instance
        return calsoftMockHttp;
    }
}
